import { FieldContext } from "./chunk-57D4P5XD.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Field/Field.Description.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var FIELD_DESCRIPTION_CLASSNAME_MAP = {};
var FieldDescription = _a => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  const {
    id,
    description
  } = useContext(FieldContext);
  if (!description) {
    return null;
  }
  return /* @__PURE__ */jsx("p", __spreadProps(__spreadValues({
    id: "".concat(id, "-description"),
    className: clsx("pd:field__description", className)
  }, rest), {
    children: description
  }));
};
var Field_Description_default = FieldDescription;
export { FIELD_DESCRIPTION_CLASSNAME_MAP, Field_Description_default };